module.exports = __webpack_public_path__ + "media/images/icons/outlined/dribbble-square-4e37749f52f657724071f056c68d48d4.svg";